import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth} from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAUcW9jil7CNeC1EtmbjPrXKd0LUFFF-2s",
  authDomain: "ryfoldzani.firebaseapp.com",
  projectId: "ryfoldzani",
  storageBucket: "ryfoldzani.appspot.com",
  messagingSenderId: "92119542106",
  appId: "1:92119542106:web:fff6439d8422b00746eb63"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

export {app, db, auth};


//email: admin@ryfoldzani.sk
//heslo: velkalesna01